import { UserModel } from './../users/user.model';
import { GroupTypeModel } from './group-type.model';
import { ActivableModel } from '@app/core/models/shared/activable.model';
import { ReferentialModel } from '../referentials/referential.model';

export class GroupDetailModel extends ActivableModel {
  constructor() {
    super();
    this.Users = [];
  }

  public Id: number;

  public Name: string;

  public Type: GroupTypeModel;

  public TypeId: number;

  public SupervisorUserId: string;

  public SupervisorUser: string;

  public ProfessionType: string;

  public ProfessionTypeId: number | null;

  public LinkedGroupId: number | null;

  public LinkedGroupName: string | null;

  public IsVoucher: boolean | null;

  public VoucherDepartment: string;

  public VoucherAnalyticalSection: string;

  public VoucherAnalyticalCode: string;

  public VoucherComment: string;

  public CanTurnOffVoucherFlag: boolean;

  public Users: UserModel[];

  public CanCreateInPPR: boolean;

  public IsPrescriptorGroup: boolean;

  public CanManageInvoiceAGI: boolean;

  public CompanyCode: string;

  public Typology: number;

  public TreeLevelValues: ReferentialModel[];
}
